import { dataHooks } from '@wix/data-hooks'

export const commonLogoWithBackDataHooks = dataHooks<{
  backBtn: {}
}>('common-logo-with-back')
